import { useState } from 'react';
import Translated from '../../feature/Translated';
import Button from 'react-bootstrap/Button';
import { ImFire } from 'react-icons/im';
import { IoChatbubblesSharp } from 'react-icons/io5';
import Modal from 'react-bootstrap/Modal';
import dateFormat from '../../../utils/date';
import classNames from 'classnames';
import { Alert } from "react-bootstrap";
import { useAdminHandleQuestionReports } from '../../../api-new';

const Reports = ({ reports, questionType, questionId, onCloseAfterHandle }) => {
  const [showReportsModal, setShowReportsModal] = useState(false);
  const handleReportsMutation = useAdminHandleQuestionReports();

  const handleReports = () => {
    handleReportsMutation.mutate({ questionType, questionId });
  }

  const handleClose = () => {
    if (handleReportsMutation.isSuccess) {
      onCloseAfterHandle && onCloseAfterHandle();
    }
    setShowReportsModal(false);
  }

  const renderHandleReportsButton = () => {
    const canRenderButton = reports.length > 0 && questionType && questionId;

    if (!canRenderButton) {
      return null;
    }

    return (
      <Button
        onClick={handleReports}
        disabled={handleReportsMutation.isPending || handleReportsMutation.isSuccess}
      >
        <Translated translationKey="mark-as-handled" />
      </Button>
    );
  }

  const renderSuccessfulAlert = () => {
    if (!handleReportsMutation.isSuccess) {
      return null;
    }

    return (
      <Alert variant="success" style={{ position: 'sticky', top: 0, zIndex: 10 }}>
        <Translated translationKey={"handled-successfully"} />
      </Alert>
    );
  }

  const renderErrorAlert = () => {
    if (!handleReportsMutation.isError) {
      return null;
    }

    return (
      <Alert variant="danger" style={{ position: 'sticky', top: 0, zIndex: 10 }}>
        <Translated translationKey={"handling-failed"} />
      </Alert>
    );
  }

  const reportElems = reports.map(report => {
    let reportContents;

    const reportDate = dateFormat.date(report.date);

    if (report.user?.email) {
      reportContents = (
        <>
          <a href={`mailto:${report.user.email}`}>{report.user.email}</a> ({reportDate}): {report.message}
        </>
      );
    } else {
      reportContents = (
        <>
          <span>{report.userId}</span> ({reportDate}): {report.message}
        </>
      );
    }

    return (
      <div key={report.id} className="mb-2">
        {reportContents}
      </div>
    );
  });

  const reportsCount = reports.length;
  const isHot = reportsCount > 2;
  const classes = classNames('underlined', 'touchable');

  const countElem = (
    <div className={classes} onClick={() => setShowReportsModal(true)}>
      <Translated translationKey="reports" /> {reportsCount}&nbsp;
      {isHot
        ? <span><IoChatbubblesSharp className="red" /><ImFire className="red" /></span>
        : <IoChatbubblesSharp />}
    </div>
  );

  const reportsModal = showReportsModal ? (
    <Modal id="book-content-modal" show={true} className="gray-light">
      <Modal.Body>
        {renderSuccessfulAlert()}
        {renderErrorAlert()}
        {reportElems}
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <div>
          {renderHandleReportsButton()}
        </div>
        <div>
          <Button
            id="close"
            onClick={handleClose}
          >
            <Translated translationKey="close" />
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  ) : null;

  return (
    <div>
      {countElem}
      {reportsModal}
    </div>
  );
};

export default Reports;